module.exports = __webpack_public_path__ + "static/media/sustained_decliner_grey.27cb928b.svg";